import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
  state: {
    data: {},
    questions: [],
    answers: [],
    answersStart: []
  },
  mutations: {
    SAVE_DATA (state, data) {
      let localStorageData = JSON.parse(localStorage.getItem('knd-quiz')) || [];
      let questions  = data['verkiezing-quiz-repeater'].reverse();
      let answersStart = questions.filter(d => d.type[0].titel !== 'Strooigoed');
      answersStart = answersStart.map(a => { 
        return {
          id: a.id 
        }
      });

      let answers = answersStart.map(a => ({...a}));
      
      localStorageData.forEach(item => {
        let index = answers.findIndex(question => question.id === item.id);
        
        if(index >= 0 ) {
          answers[index] = item;
        }
      })
      
      state.data = data;
      state.questions = questions;
      state.answers = answers;
      state.answersStart = answersStart;
    },
    
    SAVE_ANSWER(state, data) {
      let index = state.answers.findIndex(question => question.id === data.id);

      if(index >= 0 ) {
        state.answers[index] = data;
      }
     
      localStorage.setItem('knd-quiz', JSON.stringify(state.answers));
    },

    RESET_ANSWERS(state) {
      state.answers = state.answersStart.map(a => ({...a}));
      localStorage.clear();
    }
  },
  getters: {
    articleItems: state => state.articles,
    answers: state => state.answers,
    totalAnswers: state => {
      let total = state.answers.filter(d => d.answered).length;
      return total;
    },
    getAnswerById: (state) => (id) => {
      const item = state.answers.find(p=> p.id === id)
      return item;
    },
    totalCorrect: (state) => {
      let totalCorrect = state.answers.filter(d => d.correct).length;
      return totalCorrect;
    },
    totalFalse: (state) => {
      let totalFalse = state.answers.filter(d => d.correct === false).length;
      return totalFalse || 0;
    }
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.VUE_APP_API +`?t=${new Date().getTime()}`)
          .then(result => {
            
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },

    saveAnswer({commit, state}, payload) {
      commit("SAVE_ANSWER", payload);
    },

    resetAnswers({commit, state}) {
      commit("RESET_ANSWERS");
    }
  },
  modules: {

  }
})
